import { useQuery } from 'react-query';

import { getRelatedCards as queryFn } from 'api/endPoints/getRelatedCards';

import {
    IAssignee,
    ICardIndicators,
    ICardType,
    IStatus,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';

export const useQueryRelatedCards = (params) => {
    return useQuery<IRelatedCardResponse[], QueryError>(['relatedCards', params], () => queryFn(params), {
        enabled:
            Boolean(params.id) &&
            params.hasOwnProperty('isVirtual') &&
            typeof params.isVirtual === 'boolean' &&
            Boolean(params.versionId),
    });
};

export interface IRelatedCardResponse {
    id: number;
    cardTitle: string;
    cardDetails: string;
    startDate: number;
    endDate: number;
    assignee: IAssignee;
    isVirtual: boolean;
    duration: number;
    float: number | null;
    laneId: {
        id: string;
        name: string;
        label: string;
    };
    type: ICardType;
    taskActivityType: string;
    category: {
        id: number;
        name: string;
        label: string;
    };
    versionDate: number;
    taskId: number;
    versionHashCode: string;
    isStartOverdue: boolean;
    isFinishOverdue: boolean;
    cardIndicators: ICardIndicators;
    submittedDurationComplete: number;
    taskActivityId: string;
    taskVersionHashCode: string;
    originalStatus: IStatus;
    status: IStatus;
}
